import { fetchFromObject } from 'helpers/object';

export default {
  getOfferField: state => field => fetchFromObject(state, field),
  hasOffer: state => !!state.offer,
  hasOfferDetail: state => !!state.offerDetail,
  hasFidelityComponent: state => {
    const customFormGroup = state.offer ? state.offer.customFormGroup : null;
    const fidelity = customFormGroup
      ? customFormGroup.filter(item => item.id === 'fidelity-card')
      : null;
    return !!fidelity;
  },
  isNonEditableField: state => field => {
    const nonEditableFields = state.offer ? state.offer.nonEditableFields : null;
    return nonEditableFields && nonEditableFields.indexOf(field) > -1;
  }
};
